import { SecurePipe } from './../pipes/secure/secure';
import { ActivatePageModule } from './../pages/activate/activate.module';
import { ActivatePage } from '../pages/activate/activate';
import { NgModule, ErrorHandler, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
// import { AngularFireModule } from 'angularfire2';
// import { AngularFireDatabaseModule } from 'angularfire2/database';
// import { FIREBASE_CONFIG } from './firebase.credentials';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
// import { AngularFireAuth } from 'angularfire2/auth';
import { HttpModule } from '@angular/http';
import { Http } from '@angular/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Vibration } from '@ionic-native/vibration';
import { Deeplinks } from '@ionic-native/deeplinks';
import { Hotspot, HotspotNetwork } from '@ionic-native/hotspot';
import { AppVersion } from '@ionic-native/app-version';

import { AndroidPermissions } from '@ionic-native/android-permissions';
import { InvitacionesService } from "./../services/invitacion/invitacion.service";
import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator/ngx';

import { Device } from '@ionic-native/device';
import { ComponentsModule } from '../components/components.module'
//import { CalendarModule } from '../MyIonicProject/ionic3-calendar-en';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { GoogleMaps } from '@ionic-native/google-maps';
import { IonicHeaderParallaxModule } from 'ionic-header-parallax';
import { InterceptorProvider } from '../providers/interceptor/interceptor';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    ComponentsModule,
    IonicHeaderParallaxModule,
    // AngularFireDatabaseModule,
    // AngularFireModule.initializeApp(FIREBASE_CONFIG),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    IonicModule.forRoot(MyApp),
    HttpModule,
    BrowserAnimationsModule,
    ActivatePageModule,
    //CalendarModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    StatusBar,
     SplashScreen, 
     Vibration,
     Deeplinks,
     InvitacionesService,
     AndroidPermissions,
     GoogleMaps,
     { provide: ErrorHandler, useClass: IonicErrorHandler }, 
    //  AngularFireAuth, 
    LaunchNavigator,
     Http, 
     HttpClient,
     AppVersion,
     Device
    //  FileTransfer,
    //  DocumentViewer,
    //  FileOpener,
    //  File
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts